import { useState } from "react";
import { ReactComponent as DownArrowIcon } from "../assets/Down.svg";
import "./EntityPicker.css";

export interface Option<T> {
  label: string;
  value: T;
  isDisabled?: boolean;
}

export interface PickerProps<T> {
  currentValue: T;
  noCurrentText: string;
  noOptionsText: string;
  disabled?: boolean;
  title?: string;
  items: Option<T>[];
  onSelect: (value: T) => void;
}

export const Picker = <T,>({
  currentValue,
  noCurrentText,
  noOptionsText,
  disabled = false,
  items,
  title,
  onSelect,
}: PickerProps<T>) => {
  const getCurrent = () => {
    if (typeof currentValue !== "undefined") {
      return items.find((i) => i.value === currentValue);
    }
    return;
  };
  const [showOptions, setShowOptions] = useState<boolean>(false);

  return (
    <div className={`picker  ${disabled ? "picker-disabled" : ""}`}>
      {title && <h1 className="col title">{title}</h1>}
      <button
        className="picker-button"
        type="button"
        disabled={disabled}
        onClick={() => {
          const newShowOptions = !showOptions;
          setShowOptions(newShowOptions);
        }}
      >
        {getCurrent()?.label ?? noCurrentText}
        <DownArrowIcon />
      </button>
      {!disabled && showOptions && (
        <div className="picker-content">
          {items.length ? (
            items.map((item, index) => (
              <button
                key={index}
                type="button"
                onClick={() => {
                  onSelect(item.value);
                  setShowOptions(false);
                }}
                disabled={item.isDisabled}
              >
                {item.label ?? noCurrentText}
              </button>
            ))
          ) : (
            <div className="picker-no-content">{noOptionsText}</div>
          )}
        </div>
      )}
    </div>
  );
};
